module.exports = __webpack_public_path__ + "img/call_suspend.555e6c3c.png";